// extracted by mini-css-extract-plugin
module.exports = {"mdrCheck":"Checkbox_mdrCheck__LTPy3","mdrCheckbox":"Checkbox_mdrCheckbox__1w5Vi"};